if (!Element.prototype.toggleAttribute) {
  Element.prototype.toggleAttribute = function (name, force) {
    let innerForce = force;
    if (innerForce !== undefined) innerForce = !!innerForce;
    if (this.hasAttribute(name)) {
      if (force) return true;
      this.removeAttribute(name);
      return false;
    }
    if (innerForce === false) return false;
    this.setAttribute(name, '');
    return true;
  };
}